import { render } from "./DepartureOverview.vue?vue&type=template&id=4e953b7c&scoped=true"
import script from "./DepartureOverview.vue?vue&type=script&lang=js"
export * from "./DepartureOverview.vue?vue&type=script&lang=js"

import "./DepartureOverview.vue?vue&type=style&index=0&id=4e953b7c&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e953b7c"]])

export default __exports__